import { useState, useEffect } from "react";

/**
 * Returns current window inner width and height, and common breakpoint flags.
 * Updates on window resize so the app stays responsive.
 */
export function useWindowSize() {
  const [size, setSize] = useState(() => ({
    width: typeof window !== "undefined" ? window.innerWidth : 1024,
    height: typeof window !== "undefined" ? window.innerHeight : 768,
  }));

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const width = size.width;
  const height = size.height;

  return {
    width,
    height,
    isWide: width > 768,
    isTablet: width > 576 && width <= 768,
    isMobile: width <= 576,
    isSidebarOverlay: width <= 768,
  };
}
